import React, { useState, useEffect } from "react";
import {
  Table,
  Modal,
  Button,
  Badge,
  Form,
  Row,
  Col,
  InputGroup,
  Spinner,
  Alert,
  Pagination,
} from "react-bootstrap";
import { FaSearch, FaRupeeSign } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
  getAllPaidJobs,
  addCommission,
  updateCommission,
  getAllCommissions,
  addSettlement,
  getSettlementsByVendorId,
  updateSettlement,
} from "../../../services/service";
import Card from "../../../components/Card";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

const NewPayment = () => {
  const [show, setShow] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [getPaidJobs, setGetPaidJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  const userName = userData?.user?.name || "Admin";
  // Commission states
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [commissionType, setCommissionType] = useState("amount");
  const [commissionValue, setCommissionValue] = useState("");
  const [commissionId, setCommissionId] = useState(null);
  const [commissionBtnText, setCommissionBtnText] = useState("Add Commission");
  const [settlementLoading, setSettlementLoading] = useState(false);
  const [useWallet, setUseWallet] = useState(false);
  const [walletDeduction, setWalletDeduction] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const totalPages = Math.ceil(totalRecords / entriesPerPage);
  const [form, setForm] = useState({
    settlementStatus: "Pending",
    settlementDate: new Date(),
    settlementMethod: "UPI",
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  const PAYMENT_STATUS_COLORS = {
    Settled: "success",
    Pending: "warning",
    InProgress: "danger",
  };

  // Fetch commission from DB
  const fetchCommission = async () => {
    try {
      const res = await getAllCommissions();
      if (res?.success && res.data?.length > 0) {
        const c = res.data[0];
        setCommissionType(c.commissionType);
        setCommissionValue(c.typeValue);
        setCommissionId(c._id);
        setCommissionBtnText("Update Commission");
        localStorage.setItem("commissionType", c.commissionType);
        localStorage.setItem("commissionValue", c.typeValue);
      } else {
        setCommissionId(null);
        setCommissionType("amount");
        setCommissionValue("");
        setCommissionBtnText("Add Commission");
        localStorage.removeItem("commissionType");
        localStorage.removeItem("commissionValue");
      }
    } catch (err) {
      console.error("Error fetching commission:", err);
    }
  };

  // Fetch payments
  const fetchPayments = async (
    page = 1,
    limit = entriesPerPage,
    searchStr = "",
    status = ""
  ) => {
    setLoading(true);
    setError("");
    try {
      const [jobsRes, settlementsRes] = await Promise.all([
        getAllPaidJobs({
          page,
          limit,
          search: searchStr,
          status,
        }),
        // getAllSettlements(),
      ]);

      if (jobsRes?.success) {
        const settlements = Array.isArray(settlementsRes?.data)
          ? settlementsRes.data
          : [];
        const jobs = jobsRes.data.map((p) => {
          const settlement = settlements.find(
            (s) => String(s.jobId) === String(p.jobId)
          );

          return {
            id: p.jobId,
            PaymentId: p.payment?.razorpayPaymentId || "-",
            status: p.status,
            vendor: p.vendor?.name?.en || p.vendor?.name || "N/A",
            price: p.price,
            amount: settlement?.amount ?? p.price,
            equipment: p.equipment?.en || p.equipment || "N/A",
            settledBy: settlement?.settledBy,
            paymentMethod: settlement?.paymentMethod,
            date: new Date(
              p.quote?.[0]?.respondedAt || p.startedAt
            ).toLocaleString(),
            settlementStatus: p?.settlementStatus,
            settlementId: settlement?._id,
            rawData: p,
          };
        });
        setGetPaidJobs(jobs);
        setTotalRecords(jobsRes.total || 0);
      }
    } catch (err) {
      setError(
        "Failed to fetch payments: " + (err?.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  const hasFetched = React.useRef(false);
  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchCommission();
      fetchPayments(currentPage, entriesPerPage, debouncedSearch, statusFilter);
    }
  }, []);

  useEffect(() => {
    if (hasFetched.current) {
      fetchPayments(currentPage, entriesPerPage, debouncedSearch, statusFilter);
    }
  }, [currentPage, debouncedSearch, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearch, statusFilter]);
  const settlementStatusOptions = ["Pending", "Settled", "InProgress"];

  const handleShow = async (payment) => {
    const jobId = payment.rawData.jobId || payment.rawData._id;
    setSettlementLoading(true);
    setShow(true);
    try {
      const res = await getSettlementsByVendorId(jobId);
      setSelectedPayment(res);
    } catch (err) {
      console.log(err);
    } finally {
      setSettlementLoading(false);
    }
  };
  const handleClose = () => {
    setSelectedPayment(null);
    setShow(false);
    setUseWallet(false);
    setWalletDeduction("");
  };
  console.log(selectedPayment, "===========selectedPayment==========")
  const handleCommissionSave = async () => {
    if (
      commissionValue === "" ||
      commissionValue === null ||
      commissionValue === undefined ||
      Number(commissionValue) === 0
    ) {
      toast.error("Commission value is required and must be greater than 0");
      return;
    }

    try {
      let res;
      if (!commissionId) {
        res = await addCommission(commissionType, commissionValue);
      } else {
        res = await updateCommission(
          commissionId,
          commissionType,
          commissionValue
        );
      }
      setShowCommissionModal(false);
      if (res?.success) {
        toast.success(
          `Commission ${commissionId ? "Updated" : "Added"} Successfully`
        );
        await fetchCommission();
        await fetchPayments();
      } else {
        toast.error("Failed to save commission");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSettlementSubmit = async (e) => {
    e.preventDefault();
    if (!selectedPayment?.job?.vendor?._id) return;
    const payload = {
      jobId: selectedPayment?.job?._id,
      vendorId: selectedPayment?.job?.vendor._id,
      amount: selectedPayment?.job?.pricing?.jobPrice,
      status: form?.settlementStatus,
      paymentDate: form?.settlementDate,
      paymentMethod: form?.settlementMethod,
      settledBy: "Eishan",
      useWalletForCommission: useWallet,
      walletAmountToDeduct: useWallet ? Number(walletDeduction) : 0,
    };
    try {
      await addSettlement(payload);
      toast.success("Settlement added successfully!");
      handleClose();
      fetchPayments();
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message);
    }

    // try {
    //   let res;
    //   if (selectedPayment.settlementId) {
    //     res = await updateSettlement(selectedPayment.settlementId, payload);
    //     toast.success("Settlement updated successfully!");
    //   } else {
    //     res = await addSettlement(payload);
    //     toast.success("Settlement added successfully!");
    //   }

    //   setGetPaidJobs((prev) =>
    //     prev.map((job) =>
    //       job.id === selectedPayment.id
    //         ? {
    //             ...job,
    //             settlementStatus: payload.status,
    //             amount: payload.amount,
    //             paymentMethod: payload.paymentMethod,
    //             settledBy: payload.settledBy,
    //           }
    //         : job
    //     )
    //   );
    //   handleClose();
    // } catch (err) {
    //   console.error(err);
    //   toast.error("Error saving settlement!");
    // }
  };

  const exportToExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Payments");
      worksheet.addRow(["Status", "JobId", "PaymentId", "Vendor", "Date"]);

      getPaidJobs.forEach((payment) => {
        worksheet.addRow([
          payment.settlementStatus || "Pending",
          payment.id,
          payment.PaymentId,
          payment.vendor,
          payment.date,
        ]);
      });

      worksheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
      });
      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellLength = cell.value ? cell.value.toString().length : 0;
          if (cellLength > maxLength) maxLength = cellLength;
        });
        column.width = maxLength + 2;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, `Payments_${new Date().toLocaleDateString()}.xlsx`);
    } catch (err) {
      console.error("Excel export error:", err);
      toast.error("Failed to export Excel.");
    }
  };

  return (
    <>
      <Row className="align-items-center mb-3">
        <Col md={4}>
          <InputGroup>
            <InputGroup.Text>
              <FaSearch />
            </InputGroup.Text>
            <Form.Control
              placeholder="Search by Equipment Name or Vendor Name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Col>
        <Col md={3} style={{ zIndex: 100 }}>
          <Form.Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All Status</option>
            {settlementStatusOptions.map((st) => (
              <option key={st} value={st}>
                {st}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Col md={5} className="text-end">
          <small className="text-muted">
            Showing {getPaidJobs.length} of {totalRecords} payments
          </small>
        </Col>
      </Row>

      {loading && (
        <div className="text-center py-5">
          <Spinner animation="border" />
          <p className="mt-2">Loading payments...</p>
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}

      <div className="row g-2 align-items-center mb-3">
        <div className="col-12 col-md-6">
          <div className="d-flex flex-wrap gap-2">
            <Button variant="light" size="sm" disabled>
              Total Payment: {totalRecords}
            </Button>
            <Button
              variant="success"
              size="sm"
              onClick={exportToExcel}
              disabled={getPaidJobs.length === 0}
            >
              Download CSV
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="d-flex flex-wrap justify-content-md-end gap-2">
            <Button variant="light" size="sm" disabled>
              Commission Type: {commissionType || "N/A"}
            </Button>
            <Button variant="light" size="sm" disabled>
              Commission:{" "}
              {commissionValue
                ? commissionType === "amount"
                  ? `₹${commissionValue}`
                  : `${commissionValue}%`
                : "N/A"}
            </Button>
            <Button
              variant={!commissionId ? "primary" : "warning"}
              size="sm"
              onClick={() => setShowCommissionModal(true)}
            >
              {commissionBtnText}
            </Button>
          </div>
        </div>
      </div>
      {!loading && (
        <>
          <Table hover responsive className="align-middle shadow-sm rounded">
            <thead className="table-light">
              <tr>
                <th>Status</th>
                <th>Equipment</th>
                <th>Address</th>
                <th>Vendor</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {getPaidJobs.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-3">
                    Payment Data Not Available
                  </td>
                </tr>
              ) : (
                getPaidJobs.map((payment) => {
                  const status = payment.settlementStatus || "Pending";
                  return (
                    <tr key={payment.id}>
                      <td>
                        <Badge
                          bg={PAYMENT_STATUS_COLORS[status] || "secondary"}
                        >
                          {status}
                        </Badge>
                      </td>
                      <td>{payment?.equipment}</td>
                      <td>{payment?.rawData?.address?.en}</td>
                      <td
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() =>
                          navigate("/dashboard/app/vendor-listing")
                        }
                      >
                        {payment.vendor}
                      </td>
                      <td>{payment.date}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleShow(payment);
                          }}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center my-3">
              <Pagination>
                <Pagination.First
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                />
                <Pagination.Prev
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
                />

                {/* Show first page if not in window */}
                {currentPage > 3 && (
                  <>
                    <Pagination.Item onClick={() => setCurrentPage(1)}>
                      1
                    </Pagination.Item>
                    {currentPage > 4 && <Pagination.Ellipsis disabled />}
                  </>
                )}

                {/* Window of pages around current page */}
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (page >= currentPage - 2 && page <= currentPage + 2) {
                    return (
                      <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </Pagination.Item>
                    );
                  }
                  return null;
                })}

                {/* Show last page if not in window */}
                {currentPage < totalPages - 2 && (
                  <>
                    {currentPage < totalPages - 3 && (
                      <Pagination.Ellipsis disabled />
                    )}
                    <Pagination.Item onClick={() => setCurrentPage(totalPages)}>
                      {totalPages}
                    </Pagination.Item>
                  </>
                )}

                <Pagination.Next
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                />
                <Pagination.Last
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          )}
        </>
      )}
      <Modal show={show} onHide={handleClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Payment Settlement Details — {selectedPayment?.job?._id}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
          {selectedPayment && (
            <div className="p-3">
              <div className="row g-3 mb-3">
                <div className="col-12 col-sm-12 col-md-6 d-flex">
                  <Card className="flex-fill bg-primary shadow-sm">
                    <Card.Header>
                      <Card.Header.Title>Job Info</Card.Header.Title>
                    </Card.Header>
                    <Card.Body className="text-white">
                      <p>
                        <strong>Equipment:</strong>{" "}
                        {selectedPayment?.job?.equipment?.name?.en}
                      </p>
                      <p>
                        <strong>Job Price:</strong>{" "}
                        <FaRupeeSign className="me-1" />₹
                        {Number(
                          Number(
                            selectedPayment?.job?.pricing?.jobPrice || 0
                          ).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </p>
                      <p>
                        <strong>Distance (Vendor → Job Location):</strong>{" "}
                        {selectedPayment?.job?.distance?.toLocaleString()} km
                      </p>

                      <p>
                        <strong>Delivery Charge Per KM:</strong>{" "}
                        <FaRupeeSign className="me-1" />
                        {Number(
                          Number(
                            selectedPayment?.job?.dilverychargePerKm || 0
                          ).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </p>

                      <p>
                        <strong>Final Delivery Charge:</strong>{" "}
                        <FaRupeeSign className="me-1" />
                        {Number(
                          Number(
                            selectedPayment?.job?.finalDeliveryCharge || 0
                          ).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </p>

                      <p>
                        <strong>Admin Commission:</strong>{" "}
                        <FaRupeeSign className="me-1" />
                        {Number(
                          Number(
                            selectedPayment?.job?.pricing?.commission || 0
                          ).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </p>
                      {/* TDS – only if not 0 */}
                      {Number(selectedPayment?.job?.pricing?.tds || 0) !== 0 && (
                        <p>
                          <strong>TDS:</strong>{" "}
                          <FaRupeeSign className="me-1" />
                          {Number(selectedPayment?.job?.pricing?.tds || 0)
                            .toFixed(2)
                            .toLocaleString("en-IN")}
                        </p>
                      )}

                      {/* CGST – only if not 0 */}
                      {Number(selectedPayment?.job?.pricing?.cgst || 0) !== 0 && (
                        <p>
                          <strong>CGST:</strong>{" "}
                          <FaRupeeSign className="me-1" />
                          {Number(selectedPayment?.job?.pricing?.cgst || 0)
                            .toFixed(2)
                            .toLocaleString("en-IN")}
                        </p>
                      )}

                      {/* SGST – only if not 0 */}
                      {Number(selectedPayment?.job?.pricing?.sgst || 0) !== 0 && (
                        <p>
                          <strong>SGST:</strong>{" "}
                          <FaRupeeSign className="me-1" />
                          {Number(selectedPayment?.job?.pricing?.sgst || 0)
                            .toFixed(2)
                            .toLocaleString("en-IN")}
                        </p>
                      )}
                      <p>
                        <strong>Payable to Vendor:</strong>{" "}
                        <FaRupeeSign className="me-1" />
                        {Number(
                          Number(
                            selectedPayment?.job?.pricing?.standardPayout || 0
                          ).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </p>
                      <p>
                        <strong>Started At:</strong>{" "}
                        {selectedPayment?.job?.startedAt}
                      </p>
                      <p>
                        <strong>Ended At:</strong>{" "}
                        {selectedPayment?.job?.endedAt}
                      </p>
                      <p>
                        <strong>Duration:</strong>{" "}
                        {selectedPayment.job.actualDurationHours}{" "}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-12 col-sm-12 col-md-6 d-flex">
                  <Card className="flex-fill bg-success shadow-sm">
                    <Card.Header>
                      <Card.Header.Title>Payment Info</Card.Header.Title>
                    </Card.Header>
                    <Card.Body className="text-white">
                      <p>
                        <strong>Customer Payment Status:</strong>{" "}
                        {selectedPayment.job.paymentStatus}
                      </p>
                      <p>
                        <strong>Customer Payout Amount:</strong>{" "}
                        <FaRupeeSign className="me-1" />
                        {Number(
                          Number(
                            selectedPayment?.job?.pricing?.customerPayout || 0
                          ).toFixed(2)
                        ).toLocaleString("en-IN")}
                      </p>
                      <p>
                        <strong>Razorpay Payment ID:</strong>{" "}
                        {selectedPayment?.payment?.razorpayPaymentId}
                      </p>
                      <p>
                        <strong>Razorpay Order ID:</strong>{" "}
                        {selectedPayment?.payment?.razorpayOrderId}
                      </p>
                      <p>
                        <strong>Customer Name:</strong>{" "}
                        {selectedPayment?.job?.customer?.name || "N/A"}
                      </p>
                      <p>
                        <strong>Customer Email:</strong>{" "}
                        {selectedPayment?.job?.customer?.email || "N/A"}
                      </p>
                      <p>
                        <strong>Customer Phone:</strong>{" "}
                        {selectedPayment?.job?.customer?.phone || "N/A"}
                      </p>
                      <p>
                        <strong>Payment Created At:</strong>{" "}
                        {selectedPayment?.payment?.createdAt
                          ? new Date(
                            selectedPayment.payment.createdAt
                          ).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : "-"}
                      </p>
                      <p>
                        <strong>Payment Updated At:</strong>{" "}
                        {selectedPayment?.payment?.updatedAt
                          ? new Date(
                            selectedPayment.payment.updatedAt
                          ).toLocaleString("en-IN", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          : "-"}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="row g-3">
                <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex">
                  <Card className="flex-fill bg-light shadow-sm">
                    <Card.Header className="pt-2 pb-2 text-center">
                      <Card.Header.Title>Customer Info</Card.Header.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>
                        <strong>Name:</strong>{" "}
                        {selectedPayment?.job?.customer?.name || "N/A"}
                      </p>
                      <p>
                        <strong>Phone:</strong>{" "}
                        {selectedPayment?.job?.customer?.phone || "N/A"}
                      </p>
                      <p>
                        <strong>Email:</strong>{" "}
                        {selectedPayment?.job?.customer?.email || "N/A"}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
                {console.log(selectedPayment, "selectedPaymentselectedPayment")}
                <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex">
                  <Card className="flex-fill bg-light shadow-sm">
                    <Card.Header className="pt-2 pb-2 text-center">
                      <Card.Header.Title>Vendor Info</Card.Header.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>
                        <strong>Name:</strong>{" "}
                        {selectedPayment?.job?.vendor?.name || "N/A"}
                      </p>
                      <p>
                        <strong>Phone:</strong>{" "}
                        {selectedPayment?.job?.vendor?.phone || "N/A"}
                      </p>
                      <p>
                        <strong>Email:</strong>{" "}
                        {selectedPayment?.job?.vendor?.email || "N/A"}
                      </p>
                      <p>
                        <strong>Wallet Balance:</strong>{" "}
                        <FaRupeeSign className="me-1" />
                        {selectedPayment?.job?.vendor?.walletBalance?.toLocaleString() ||
                          0}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex">
                  <Card className="flex-fill bg-light shadow-sm">
                    <Card.Header className="pt-2 pb-2 text-center">
                      <Card.Header.Title>Location</Card.Header.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>{selectedPayment?.job?.address || "N/A"}</p>
                      <p>
                        <strong>Latitude:</strong>{" "}
                        {selectedPayment?.job?.latitude}
                      </p>
                      <p>
                        <strong>Longitude:</strong>{" "}
                        {selectedPayment?.job?.longitude}
                      </p>
                    </Card.Body>
                  </Card>
                </div>
                {selectedPayment?.bankDetails && (
                  <div className="col-12 col-sm-6 col-md-6 col-lg-3 d-flex">
                    <Card className="flex-fill bg-light shadow-sm">
                      <Card.Header className="pt-2 pb-2 text-center">
                        <Card.Header.Title>Bank Details</Card.Header.Title>
                      </Card.Header>
                      <Card.Body>
                        <p>
                          <strong>BankName:</strong>{" "}
                          {selectedPayment?.bankDetails?.bankName || "N/A"}
                        </p>
                        <p>
                          <strong>Account Number:</strong>{" "}
                          {selectedPayment?.bankDetails?.accountNumber || "N/A"}
                        </p>
                        <p>
                          <strong>Account Holder Name:</strong>{" "}
                          {selectedPayment?.bankDetails?.accountHolderName ||
                            "N/A"}
                        </p>
                        <p>
                          <strong>IFSC Code:</strong>{" "}
                          {selectedPayment?.bankDetails?.ifscCode}
                        </p>
                      </Card.Body>
                    </Card>
                  </div>
                )}
              </div>

              <div className="mt-3">
                <Card className="flex-fill bg-white shadow-sm">
                  <Card.Header>
                    <Card.Header.Title>Settlement</Card.Header.Title>
                  </Card.Header>
                  <Card.Body>
                    {selectedPayment?.settlement?.status == "Settled" && (
                      <Card className="mb-3 bg-light shadow-sm">
                        <Card.Header>
                          <Card.Header.Title>
                            Current Settlement Details
                          </Card.Header.Title>
                        </Card.Header>
                        <Card.Body>
                          <p>
                            <strong>Status:</strong>{" "}
                            {selectedPayment.settlement?.status}
                          </p>
                          <p>
                            <strong>Amount:</strong> ₹
                            {selectedPayment?.settlement?.amount}
                          </p>
                          <p>
                            <strong>Payment Method:</strong>{" "}
                            {selectedPayment?.settlement?.paymentMethod || "-"}
                          </p>
                          <p>
                            <strong>Settled By:</strong>{" "}
                            {selectedPayment?.settlement?.settledBy || "-"}
                          </p>
                          <p>
                            <strong>Payment Date:</strong>{" "}
                            {selectedPayment?.settlement?.paymentDate
                              ? new Date(
                                selectedPayment.settlement.paymentDate
                              ).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                              : "-"}
                          </p>
                          {selectedPayment?.settlement?.invoiceUrl && (
                            <p>
                              <strong>Invoice:</strong>{" "}
                              <a
                                href={selectedPayment.settlement.invoiceUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary ms-2"
                              >
                                Download Invoice
                              </a>
                            </p>
                          )}
                        </Card.Body>
                      </Card>
                    )}
                    {selectedPayment?.settlement?.status !== "Settled" &&
                      settlementLoading ? (
                      <div className="d-flex align-items-center gap-2">
                        <Spinner animation="border" size="sm" />
                        <span>Loading settlement…</span>
                      </div>
                    ) : (
                      selectedPayment?.settlement?.status !== "Settled" && (
                        <Form onSubmit={handleSettlementSubmit}>
                          <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                              name="status"
                              required
                              value={form?.settlementStatus || "Pending"}
                              onChange={(e) =>
                                setForm((prev) => ({
                                  ...prev,
                                  settlementStatus: e.target.value,
                                }))
                              }
                            >
                              <option value="Pending">Pending</option>
                              <option value="Settled">Settled</option>
                              <option value="InProgress">InProgress</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>Payment Date</Form.Label>
                            <Form.Control
                              type="date"
                              name="paymentDate"
                              min={new Date().toISOString().split("T")[0]}
                              defaultValue={
                                form.settlementDate
                                  ? new Date(form.settlementDate)
                                    .toISOString()
                                    .split("T")[0]
                                  : new Date().toISOString().split("T")[0]
                              }
                              onChange={(e) =>
                                setForm((prev) => ({
                                  ...prev,
                                  settlementDate: new Date(e.target.value),
                                }))
                              }
                            />
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>Payment Method</Form.Label>
                            <Form.Select
                              name="paymentMethod"
                              required
                              defaultValue={form?.settlementMethod || "UPI"}
                              onChange={(e) =>
                                setForm((prev) => ({
                                  ...prev,
                                  settlementMethod: e.target.value,
                                }))
                              }
                            >
                              <option value="UPI">UPI</option>
                              <option value="Bank Transfer">
                                Bank Transfer
                              </option>
                              <option value="Net Banking">Net Banking</option>
                              <option value="Cash">Cash</option>
                              <option value="Card">Card</option>
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Check
                              type="checkbox"
                              label="Deduct from Wallet"
                              checked={useWallet}
                              onChange={(e) => setUseWallet(e.target.checked)}
                            />
                          </Form.Group>

                          {useWallet && (
                            <Form.Group className="mb-3">
                              <Form.Label>Wallet Deduction Amount</Form.Label>
                              <Form.Control
                                type="number"
                                value={walletDeduction}
                                min={0}
                                max={
                                  selectedPayment?.job.vendor?.walletBalance ||
                                  0
                                }
                                step="1"
                                onWheel={(e) => e.target.blur()}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  // Empty allow (user delete kare toh)
                                  if (value === "") {
                                    setWalletDeduction("");
                                    return;
                                  }

                                  const num = Number(value);

                                  // Extra safety
                                  if (num < 0) return;

                                  setWalletDeduction(num);
                                }}
                              />
                              <Form.Text className="text-muted">
                                Max available:{" "}
                                {selectedPayment?.job.vendor?.walletBalance ||
                                  0}
                              </Form.Text>
                            </Form.Group>
                          )}
                          <Button type="submit">Add Settlement</Button>
                        </Form>
                      )
                    )}
                  </Card.Body>
                </Card>
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCommissionModal}
        onHide={() => setShowCommissionModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{commissionBtnText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Commission Type</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="Amount (₹)"
                  name="commissionType"
                  value="amount"
                  checked={commissionType === "amount"}
                  onChange={(e) => setCommissionType(e.target.value)}
                />
                <Form.Check
                  type="radio"
                  label="Percentage (%)"
                  name="commissionType"
                  value="percent"
                  checked={commissionType === "percent"}
                  onChange={(e) => setCommissionType(e.target.value)}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Commission Value</Form.Label>
              <Form.Control
                type="number"
                value={commissionValue}
                onChange={(e) => setCommissionValue(e.target.value)}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setShowCommissionModal(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" size="sm" onClick={handleCommissionSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NewPayment;
